module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-textfield"
  }, [_c('v-text-field', {
    ref: "field",
    attrs: {
      "label": _vm.label,
      "required": "",
      "value": _vm.value,
      "rules": _vm.mandatory,
      "readonly": _vm.readonly
    },
    on: {
      "input": _vm.onChange,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.onArrowDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.onArrowUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }],
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "autocomplete-results",
    attrs: {
      "id": "autocomplete-results"
    }
  }, _vm._l((_vm.results), function(result, i) {
    return _c('div', {
      directives: [{
        name: "touch",
        rawName: "v-touch:tap",
        value: (_vm.tapHandler(i)),
        expression: "tapHandler(i)",
        arg: "tap"
      }],
      key: i,
      staticClass: "autocomplete-result",
      class: {
        'is-active': i === _vm.arrowCounter, 'accent': i === _vm.arrowCounter
      },
      on: {
        "click": function($event) {
          _vm.setResult(result)
        }
      }
    }, [_vm._v("\n      " + _vm._s(result) + "\n    ")])
  }))], 1)
},staticRenderFns: []}